export const defaultData = {
  contractorDetails: {
    companyName: '',
    engineerName: '',
    tradeCompetencyNo: '',
    telephone: ''
  },
  siteDetails: {
    clientName: '',
    siteAddress: '',
    postCode: '',
    workDate: new Date().toISOString().split('T')[0]
  },
  scopeOfWorks: {
    workActivityType: 'New Installation & Commissioning',
    equipmentCategory: 'HVAC / Heat Pump / Chiller System',
    equipmentMakeModel: '',
    serialNumber: '',
    locationInBuilding: 'Plant Room'
  },
  safeIsolationAndEnvironment: {
    safeIsolationCompleted: 'Yes - Verified Proved Dead',
    gasOrFuelIsolated: 'N/A',
    fGasRecovered: 'N/A - No Fluorinated Gases',
    refrigerantTypeAndWeightKg: '',
    wasteTransferCertNumber: '',
    glycolOrFluidDisposalMethod: 'Closed Loop Unopened'
  },
  commissioningReadings: {
    operatingPressureBar: 1.8,
    flowTemperatureC: 45.0,
    electricalVoltageAndAmps: '230V 1-Phase / 14.2A FLC',
    safetyInterlocksVerified: 'Yes - All Operational',
    manufacturersChecklistAttached: 'Yes - Benchmark / Warranty Log Stamped'
  },
  handoverAndSignatures: {
    completionStatus: 'COMMISSIONED & LIVE IN OPERATION',
    engineerComments: 'Equipment installed and commissioned in accordance with manufacturer instructions and statutory standards. Client trained on user controls.',
    engineerSignature: '',
    clientSignature: ''
  }
};

export default defaultData;
